import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
declare let bootstrap: any;

@Component({
  selector: 'app-family-delete-confirmation-modal',
  imports: [TranslocoModule],
  templateUrl: './family-delete-confirmation-modal.component.html',
  styleUrl: './family-delete-confirmation-modal.component.scss',
})
export class FamilyDeleteConfirmationModalComponent {
  private modalInstance!: any;
  @Output() confirm: EventEmitter<void> = new EventEmitter();

  public closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }
  public delete() {
    this.confirm.emit();
    this.closeModal();
  }
  public openModalq() {
    const modalElement = document.getElementById('exampleModalFamily');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      this.modalInstance.show();
    }
  }
}
